import React from 'react';
import { SvgIcon } from '@onsolve/onsolve-ui-components';

const ConferenceBridgeSettings = props => (
    <SvgIcon {...props}>
        <path
            d="M7.258 1.006v1.666H3.83a.277.277 0 00-.276.26v10.67c0 .148.114.269.26.277h7.425a.277.277 0 00.276-.26V7.67h.554v8.05c0 .096-.01.19-.028.281H3.028a1.395 1.395 0 01-.027-.233L3 15.719V2.394c0-.756.603-1.37 1.352-1.387h2.906zM16 0v2.22h-5.673a.277.277 0 00-.276.26v.017c0 .148.114.269.26.277H16v4.44h-5.301L8.283 9.1a.276.276 0 01-.446-.201V1.387c0-.755.602-1.37 1.352-1.387H16zm-3.182 4.44h-2.491a.277.277 0 00-.017.554h2.507a.277.277 0 00.017-.554h-.016zM7.585 15.597a.553.553 0 100-1.107.553.553 0 000 1.107z"
            fillRule="evenodd"
            stroke="none"
        />
    </SvgIcon>
);

export default ConferenceBridgeSettings;
